import { useGetStoresCatalogQuery } from "@/services/store/select-options";
import { useMemo } from "react";
import { StoreRecord, StoreWire } from "../dtos/ofm-dtos";

function normalize(wire?: StoreWire[] | null): StoreRecord[] {
  if (!wire) return [];
  return wire.map((s) =>
    "code" in s
      ? { code: String(s.code), cnpj: s.cnpj ? String(s.cnpj) : undefined }
      : { code: String(s.value), cnpj: (s as any)?.cnpj ? String((s as any).cnpj) : undefined }
  );
}

function compare(a: StoreRecord, b: StoreRecord) {
  const an = Number(a.code), bn = Number(b.code);
  if (!Number.isNaN(an) && !Number.isNaN(bn) && an !== bn) return an - bn;
  return a.code.localeCompare(b.code);
}

export function useStoresCatalog() {
  const { data, isFetching, isError, refetch } = useGetStoresCatalogQuery(undefined, { });

  const stores = useMemo(
    () => normalize(data as StoreWire[] | undefined).sort(compare),
    [data]
  );

  return {
    stores,
    isLoading: isFetching && stores.length === 0,
    isError,
    refresh: refetch,
  };
}
